import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { GraduationCap, ShieldAlert, ArrowRight } from 'lucide-react';

const TeacherRegister = () => {
  return (
    <div className="min-h-screen bg-[#FFFFFF] flex flex-col">
      {/* Header */}
      <header className="bg-[#FFFFFF] border-b border-[#E8DFCF] py-4 px-4">
        <div className="max-w-7xl mx-auto">
          <Link to="/" className="flex items-center gap-3 w-fit">
            <img src="/logo.png" alt="Logo" className="w-10 h-10 rounded-lg object-cover border border-[#d4a853]/30" />
            <span className="text-xl font-bold text-[#d4a853]">المعتمد في اللغة العربية</span>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center p-4">
        <Card className="w-full max-w-md bg-[#FFFFFF]/80 border border-[#d4a853]/30 shadow-[0_0_30px_rgba(212,168,83,0.1)]">
          <CardHeader className="text-center pb-2">
            <div className="w-16 h-16 bg-[#d4a853]/10 border border-[#d4a853]/30 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <ShieldAlert className="w-8 h-8 text-[#d4a853]" />
            </div>
            <CardTitle className="text-2xl font-bold text-[#412402]">
              تسجيل المعلمين غير متاح
            </CardTitle>
            <CardDescription className="text-[#6B4C2A]">
              يتم إنشاء حسابات المعلمين بواسطة مدير النظام فقط
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="bg-[#d4a853]/10 border border-[#d4a853]/30 rounded-lg p-4 text-center">
              <p className="text-[#d4a853] text-sm">
                إذا كنت معلماً وتحتاج إلى حساب، يرجى التواصل مع مدير النظام.
              </p>
            </div>
            
            <div className="space-y-3">
              <Link to="/teacher/login" className="block">
                <Button className="w-full bg-gradient-to-r from-[#d4a853] to-[#8b5a2b] hover:from-[#f5d789] hover:to-[#d4a853] text-[#0a0a0a] font-bold">
                  تسجيل الدخول كمعلم
                  <ArrowRight className="w-4 h-4 mr-2" />
                </Button>
              </Link>
              
              <Link to="/" className="block">
                <Button variant="outline" className="w-full">
                  العودة للصفحة الرئيسية
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default TeacherRegister;
